export const components = {
    'a[data-is=smooth-scroll]': 'smooth-scroll',
    'astrology-compatibility': 'compatibility/astrology',
    'birthday-select': 'birthday-select',
    'bt-subscription-form': 'bt-subscription-form',
    'card-slider': 'card-slider',
    'chinese-zodiac-signs': 'chinese-zodiac-signs',
    'chinese-zodiac-sign-datepicker': 'chinese-zodiac-sign-datepicker',
    'compatibility-chooser': 'compatibility/chooser',
    'cordial': 'cordial',
    'daily-hexagram': 'daily/hexagram',
    'daily-number': 'daily/number',
    'daily-tarot-card': 'daily/tarot-card',
    'date-picker': 'date-picker',
    'deck-selector': 'deck-selector',
    'ga-events': 'ga-events',
    'horoscope': 'horoscope',
    'keen': 'keen',
    'keen-slider': 'keen-slider',
    'logged-in': 'logged-in',
    'logged-out': 'logged-out',
    'mobile-menu': 'nav/mobile-menu',
    'modal': 'modals/index',
    'moon-phase': 'moon-phase',
    'nav-dropdown': 'nav/nav-dropdown',
    'nav-submenu': 'nav/submenu',
    'newsletter': 'newsletter/index',
    'notifications': 'notifications',
    'planet-tracker': 'planet-tracker',
    'policy-consent': 'policy-consent',
    'product-carousel': 'product-carousel',
    'product-message': 'product-message',
    'product-teeup': 'product-teeup',
    'promo-message': 'promo-message',
    'promo-message-preview': 'promo-message-preview',
    'promoted-content': 'content/promoted',
    'sale-message': 'sale-message',
    'search-site': 'search-site',
    'service-contact-form': 'service-contact-form',
    'subscription-teeup': 'teeups/subscription',
    'tarot-card-autocomplete': 'tarot/card/autocomplete',
    'tarot-card-browser': 'tarot/card/browser',
    'tarot-card-selector': 'tarot/card/selector',
    'tarot-deck-autocomplete': 'tarot/deck/autocomplete',
    'tarot-deck-filters': 'tarot/deck/filters',
    'tarot-deck-selector': 'tarot/deck/selector',
    'top-nav': 'nav/top',
    'upsell-button': 'upsell-button',
    'user-menu': 'user/menu.js',
    'zodiac-dropdown': 'zodiac-dropdown',
    'zodiac-sign-picker': 'zodiac-sign-picker',
};
